import { RegisterOptions } from 'react-hook-form';
import { PASSWORD_VALIDATOR_PATTERN } from '../constants/global-constants';

/**
 * For given passwordType, returns the password validation errors map.
 * @param passwordType - Type of the password.
 * @param actualPasswordValue - Value of the actual password field.
 * @returns - Returns the password validation messages.
 */
export const parsePasswordValidationMap = (
  passwordType: 'password' | 'confirm password',
  actualPasswordValue?: string
): RegisterOptions => {
  const passwordValidationMap: RegisterOptions = {
    required: `Please enter the ${passwordType}`
  };

  if (passwordType === 'password') {
    passwordValidationMap.pattern = {
      value: PASSWORD_VALIDATOR_PATTERN,
      message: `Password should contain at least 1 uppercase, 1 lowercase, 1 digit,
  1 special character, have a length of at least of 10 and no whitespace`
    };
  } else {
    /**
     * Used to check whether the password and confirm password values are same.
     * @param currentPassword - Value of the Confirm Password Field.
     * @returns - Error Message.
     */
    passwordValidationMap.validate = (currentPassword): any => {
      return currentPassword !== actualPasswordValue
        ? 'Password and confirm password should match'
        : null;
    };
  }

  return passwordValidationMap;
};

export default parsePasswordValidationMap;
